module.exports = __webpack_public_path__ + "img/missed_notification_black.9569dafe.svg";